import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WS_NS } from './register';

/** The `ws` t(): a key (module-prefixed, e.g. 'home.queue.title') and optional interpolation / count / defaultValue. */
export type WsT = (key: string, options?: Record<string, unknown>) => string;

/**
 * `t` bound to the `ws` namespace (re-renders on a language switch like useTranslation()).
 *   const { t, lang } = useWsT();  t('home.queue.title')
 * (useTranslation('ws') does not type-check with this repo's TypeScript 4.9 + i18next 25 typings — use this.)
 */
export function useWsT() {
  const { i18n } = useTranslation();
  const lang = i18n.language || 'ar';
  const t = useMemo(() => i18n.getFixedT(lang, WS_NS), [i18n, lang]) as unknown as WsT;
  return { t, i18n, lang, ar: lang.startsWith('ar') };
}
